import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FleetService {

  private saveFleetUrl = '/api/fleet/saveFleet';

  constructor(protected httpClient:HttpClient) { }

  saveFleet(fleet):Observable<any> {

    return this.httpClient.post(this.saveFleetUrl,fleet);

  }
}
